import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Color } from 'src/app/model/index.model';

@Component({
  selector: 'app-lst-colors',
  templateUrl: './lst-colors.component.html',
  styleUrls: ['./lst-colors.component.scss']
})
export class LstColorsComponent implements OnInit {
 /*
   * Varaiables de control para comportamientos del componente
 */
 @Output()
 finalizado: EventEmitter<Color[]> = new EventEmitter<Color[]>();
 
 @Input()
 set listado(event: Color[]) {
   if (event) {
     this.items = event;
   }
 }
  item :Color
  items:Color[]

  constructor() {
    this.item=new Color()
    this.items=[]
   }

  ngOnInit() {
  }
  add(){
    if (this.item.hex.length>0&& this.item.nombre.length>2){
      this.items.unshift(this.item)
      this.item=new Color()
      this.finalizado.emit(this.items)
    }
  }
  remove(ite:Color){
   let i= this.items.indexOf(ite)
   if (i > -1) { // only splice array when item is found
    this.items.splice(i, 1); // 2nd parameter means remove one item only
    this.finalizado.emit(this.items)
   }
  }
}
